import React from 'react'
import { bool, string } from 'prop-types'
import { Typography, Divider, CardContent, Skeleton } from '@mui/material'

export default function SimpleCard({
  title,
  subtitle,
  footer,
  loading = true
}) {
  return (
    <React.Fragment>
      <CardContent>
        {loading === true ? (
          <Skeleton animation="wave" height={50} width="100%" />
        ) : (
          <Typography variant="h5" marginBottom="8px" component="div">
            {title}
          </Typography>
        )}

        {loading === true ? (
          <Skeleton animation="wave" height={30} width="80%" />
        ) : (
          <Typography
            variant="body"
            color="primary"
            fontWeight="bold"
            fontSize="1rem"
            textTransform="capitalize"
            marginTop="10px"
          >
            {subtitle}
          </Typography>
        )}
        <Divider />

        {loading === true ? (
          <Skeleton animation="wave" height={30} width="40%" />
        ) : (
          <Typography
            sx={{ color: 'text.secondary', mt: 1.2, mb: 0, fontSize: '1.2rem' }}
          >
            {footer}
          </Typography>
        )}
      </CardContent>
    </React.Fragment>
  )
}

SimpleCard.propTypes = {
  title: string,
  subtitle: string,
  footer: string,
  loading: bool
}
